module.exports = __webpack_public_path__ + "img/uc_11.91c76810.png";